export const themes = {
  default: {
    thCard: 'flex rounded-12 bg-white font-bold',
    thClose:
      'shrink-0 border-s-1 border-lightGrey p-10 text-black transition-colors duration-250 ease-in hocus:text-black-active',
    thCloseIconWidth: '0.625rem',
    thContent: 'flex flex-1 items-center gap-5 p-10',
  },
  // The design system's "Advanced Toaster": a title over a text, framed in the toast color.
  advanced: {
    thCard: 'flex max-w-400 rounded-16 border-1 border-current bg-white',
    thClose:
      'absolute end-0 top-0 p-20 text-black transition-colors duration-250 ease-in hocus:text-black-active',
    thCloseIconWidth: '0.75rem',
    thContent: 'flex flex-1 items-start gap-15 p-20 pe-50',
  },
};
